The input parameter for the `createCandidateProcessHistoryItem` mutation.
